<template>
    <div class="auth container-fluid">
        <div class="row justify-content-center">
            <div class="col-xl-6 col-lg-8 col-md-10 col-sm-12">
                <div class="locale_block password_reset_page">
                    <locale-button class="locale_block__button--first" language="nl"/>
                    <locale-button class="locale_block__button" language="fr"/>
                </div>
                <div class="block--auth has-no-top-margin">
                    <img class="logo" src="/static/img/logo_minimax.png" alt="Minimax Client Dashboard" title="Minimax Client Dashboard" height="32px">
                    <p>{{ $t('auth.header_sub_reset_password') }}</p>
                    <form class="form" @submit.prevent="change">
                        <h1>{{ $t('auth.header_reset_password') }}</h1>
                        <span class="floating-label">{{$t('auth.new_password')}}</span>
                        <div class="form__group">
                            <i class="form__input__icon mdi mdi-textbox-password"></i>
                            <input class="form__input--text underline has-icon"
                                   type="password"
                                   autocomplete="password"
                                   placeholder="****"
                                   v-model="credentials.password"
                            />
                        </div>
                        <span class="floating-label">{{$t('auth.repeat_new_password')}}</span>
                        <div class="form__group">
                            <i class="form__input__icon mdi mdi-textbox-password"></i>
                            <input class="form__input--text underline has-icon"
                                   type="password"
                                   autocomplete="password"
                                   placeholder="****"
                                   v-model="credentials.passwordRepeat"
                            >
                        </div>
                        <div class="form__buttons">
                            <button type="submit" class="button--cta"
                                    :disabled="!formValidated"
                                    :class="{'is-loading': loading}">
                                {{$t('auth.button_change_password')}}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Watch } from 'vue-property-decorator';
    import LocaleButton from '../../general/LocaleButton';
    import {SUBMIT_PASSWORD_CHANGE} from '../../../store/modules/auth';

    @Component({
        components: {LocaleButton}
    })
    export default class PasswordResetForm extends Vue {
        name = 'password-reset-form';
        loading = false;
        error = '';
        formValidated = false;
        credentials = {
            password: '',
            passwordRepeat: ''
        };

        @Watch('credentials', {deep: true})
        validate(){
            if (this.credentials.password == this.credentials.passwordRepeat){
                if (this.credentials.password.length > 6) {
                    this.formValidated = true;
                }
            } else {
                this.formValidated = false;
            }
        }

        async change(){
            this.loading = true;
            var token = this.$route.params.token;
            let payload = {};
            payload.token = token;
            payload.password = this.credentials.password;
            payload.repeat_password = this.credentials.passwordRepeat;
            try {
                await this.$store.dispatch(SUBMIT_PASSWORD_CHANGE, payload);
                this.$notify.success(this.$t('auth.notify_success_reset_password'));
                this.$router.replace({
                    name: 'account'
                });
            } catch (e){
                if (e.response && e.response.data){
                    let data = e.response.data;
                    this.error = data.errors;
                    switch (this.error){
                    case 'Invalid token':
                        this.$notify.error(this.$t('auth.notify_failures.password_reset.invalid_token'));
                        break;
                    default:
                        this.$notify.error(this.$t('auth.notify_failures.reset_password.general'));
                    }
                } else {
                    this.$notify.error(this.$t('auth.notify_failures.reset_password.general'));
                }
            } finally {
                this.loading = false;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/auth/forms/PasswordResetForm.vue